import { c as n, cB as i } from "./ghl-ui.es384.js";
const l = n([i("input-number-suffix", `
 display: inline-block;
 margin-right: 10px;
 `), i("input-number-prefix", `
 display: inline-block;
 margin-left: 10px;
 `)]);
export {
  l as default
};
